// extracted by css-extract-rspack-plugin
export default {"input":"sL8mQ","button":"Y_vzy"};